export default {
  __name: 'PageHeader',
  setup: function setup(__props) {
    var handleSelect = function handleSelect() {};
    return {
      __sfc: true,
      handleSelect: handleSelect
    };
  }
};